import React, { useEffect, useState } from "react";
import styled from "@emotion/styled";
import { NavLink, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import {
  Add as AddIcon,
  Archive as ArchiveIcon,
  FilterList as FilterListIcon,
  RemoveRedEye as RemoveRedEyeIcon,
} from "@mui/icons-material";
import {
  Link,
  Breadcrumbs as MuiBreadcrumbs,
  Card as MuiCard,
  CardContent as MuiCardContent,
  Divider as MuiDivider,
  Paper as MuiPaper,
  Typography,
  Button,
  CircularProgress,
  TextField,
  InputLabel,
  FormControl,
  MenuItem,
  Select,
  LinearProgress,
  TextareaAutosize,
  Switch,
  FormControlLabel,
  List,
  ListItem,
  IconButton,
  ListItemAvatar,
  Avatar,
  ListItemText,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { Box, spacing } from "@mui/system";
import useAuth from "../../../hooks/useAuth";
import Grid from "@mui/system/Unstable_Grid";
import InputMask from "react-input-mask";
import Tiptap from "../../../Tiptap";
import DeleteIcon from '@mui/icons-material/Delete';
import FileCopyIcon from '@mui/icons-material/FileCopy';

const Divider = styled(MuiDivider)(spacing);

function TicketAddMessageBody(props) {
  let {
    body,
    message,
    setMessage,
    status,
    setStatus,
    sendNotification,
    setSendNotification,
    sendNotificationHandle,
    loadingOnSave,
    statusList,
    setInternalNote,
    internalNote,
    setListUploadVal,
    listUploadVal
  } = props;


  const [savingId, setsavingId] = React.useState(false);

  const UploadComponentUp = async (e) => {
  
    let filename = e.target.files[0].name;

    var reader = new FileReader();
    reader.readAsDataURL(e.target.files[0]);
    reader.onload = function (e) {
      let base64Image = reader.result;

      let upTMP = {
        key: Math.floor(Math.random() * 100),
        file: String(base64Image)
          .replace(/^data:image\/[a-z]+;base64,/, "")
          .replace("data:", "")
          .replace(/^.+,/, ""),
        name: filename,
      };

      let tmpVLa = [...listUploadVal, upTMP];

      setListUploadVal(tmpVLa);
    };
  };

  const RemoveUploadComponentUp = (list, value) => {
    let indexOfTmp = list.indexOf(value);
    list = list.splice(indexOfTmp > 0 ? indexOfTmp : 1, 1);

    setListUploadVal(list);
  };

  return (
    <React.Fragment>
      <Grid container justifyContent={"center"}>
        <Box
          my={4}
          alignItems="center"
          gap={4}
          p={2}
          sx={{ border: "1px solid grey", width: "90%" }}
        >
          <Tiptap onUpdateHandle={(e) => setMessage(e)} />
          {/* <TextareaAutosize defaultValue={message} 
                onChange={e=> setMessage(e.target.value)}  minRows={8} lang="pt-Br" style={{width:"100%"}}/> */}

          <Grid container justifyContent={"left"} mt={4} mb={4}>
            <React.Fragment>
            <Button variant="contained" component="label" onChange={e=> UploadComponentUp(e)}  >
                Escolher arquivo
                <input hidden type="file" accept="image/*,application/pdf" />
              </Button>
            </React.Fragment>
          </Grid>

          <Grid sx={{maxWidth:450}}>
            <List dense={false}>
          {listUploadVal.map(elc => (
              savingId==false && 
                <ListItem 
                secondaryAction={
                  <IconButton  edge="end" aria-label="delete" onClick={e => RemoveUploadComponentUp(listUploadVal, elc)}>
                    <DeleteIcon />
                  </IconButton>
                } >
                <ListItemAvatar>
                  <Avatar>
                    <FileCopyIcon />
                  </Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary={elc.name}
                  secondary={false ? 'Secondary text' : null}
                />
              </ListItem>
            ))}
                
            </List>
          </Grid>

          <FormControl sx={{ width: "200px", marginRight: 10 }}>
            <InputLabel id="demo-simple-select-label">Status</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={status}
              label="Status"
              onChange={(e) => setStatus(e.target.value)}
            >
              {statusList &&
                statusList.map((row) => (
                  <MenuItem value={row.account_requests_status_id}>
                    {row.name}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
          <FormControlLabel
            control={
              <Switch
                defaultChecked={sendNotification}
                onClick={(e) => setSendNotification(!sendNotification)}
              />
            }
            label="Enviar E-mail"
          />

          <FormControlLabel
            control={
              <Switch
                defaultChecked={internalNote}
                onClick={(e) => setInternalNote(!internalNote)}
              />
            }
            label="Anotação Interna"
          />

          <Grid container justifyContent={"center"}>
            {!loadingOnSave && (
              <Button
                variant="contained"
                size="large"
                onClick={(e) => sendNotificationHandle()}
              >
                Enviar
              </Button>
            )}
            {loadingOnSave && (
              <Grid item>
                <Box sx={{ display: "flex" }}>
                  <CircularProgress />
                </Box>
              </Grid>
            )}
          </Grid>
        </Box>
      </Grid>

      <Divider my={6} />
    </React.Fragment>
  );
}

export default TicketAddMessageBody;
